import { useI18n } from "vue-i18n";
export function useTrans() {
    const { t } = useI18n();
    const trans = (message, values = {}) => {
        return t(message, values, { default: message });
    };
    return { trans };
}
